import React, { useState } from 'react';
import { Box, Paper, Typography, Button, IconButton, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import LaunchIcon from '@mui/icons-material/Launch';
import './WebAppEmbed.scss';

interface WebAppEmbedProps {
    title: string;
    url: string;
    onClose?: () => void;
}

const WebAppEmbed: React.FC<WebAppEmbedProps> = ({ title, url, onClose }) => {
    const [isLoading, setIsLoading] = useState(true);

    const handleLoad = () => {
        setIsLoading(false);
    };

    return (
        <Paper className="web-app-embed" elevation={3}>
            <Box className="web-app-embed-header">
                <Typography variant="h6">{title}</Typography>
                <Box>
                    <IconButton
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        size="small"
                        aria-label="Open in new tab"
                    >
                        <OpenInNewIcon />
                    </IconButton>
                    {onClose && (
                        <IconButton
                            onClick={onClose}
                            size="small"
                            aria-label="Close embed"
                        >
                            <CloseIcon />
                        </IconButton>
                    )}
                </Box>
            </Box>
            <Box className="web-app-embed-container">
                {isLoading && (
                    <Box className="loading-container">
                        <CircularProgress size={48} />
                        <Typography variant="body2" sx={{ mt: 2 }}>
                            Loading web app...
                        </Typography>
                    </Box>
                )}
                <iframe
                    src={url}
                    title={title}
                    className="web-app-iframe"
                    frameBorder="0"
                    onLoad={handleLoad}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
                />
            </Box>
            <Box className="web-app-embed-footer">
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<LaunchIcon />}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    fullWidth
                >
                    Open in Full Screen
                </Button>
            </Box>
        </Paper>
    );
};

export default WebAppEmbed; 